import './AddMaintenanceForm.css'
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

// import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function AddMaintenanceForm() {
    const userinfo = useSelector((state) => state);
    const { currentLocal } = useSelector((state) => state.currentLocal);
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    // eslint-disable-next-line react-hooks/rules-of-hooks
            const {id}=useParams()

    // eslint-disable-next-line react-hooks/rules-of-hooks
      const [items, setItems] = useState([])
    
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [price, setPrice] = useState(items[0]?.price)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [description, setDescription] = useState('')
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [password, setPssword] = useState('')
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [phone, setPhone] = useState('')

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [loading, setLoading] = useState('')
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleRemoveImage = () => {
        setImage(null);
        setPreview(null);
    };

  useEffect(() => {
    const getAllApis = async () => {
const endPoint=localStorage.getItem("type") !== "maintenance"?
`https://nanosoft.space/taarteb/public/api/admin/maintenances`
:
`https://nanosoft.space/taarteb/public/api/my-maintenances`
      await axios
        .get(endPoint, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {
  const filteredItem=res.data.data.filter((item)=>item?.id==id)
  
        setItems([filteredItem]); // keep item if you need
        setDescription(filteredItem?.[0]?.description || "");
        setPrice(filteredItem?.[0]?.price || "");
setImage(null); // no local File yet
setPreview(filteredItem?.[0]?.image || null); // show existing API image

        })
        .catch((error) => {





        });

    }
    if(id){
    getAllApis()
    }
  }, [id])
const handleSubmit = async (e) => {
 e.preventDefault();
    setLoading(true);

    try {
        const formData = new FormData();
        formData.append("description", description);
        formData.append("price", price);
const today = new Date().toISOString().split("T")[0];
formData.append("date", today);


        if (image) {
            formData.append("image", image); // 👈 image file
        }

        // send request
      if(id){
  const response = await axios.post(
            `https://nanosoft.space/taarteb/public/api/maintenances/${id}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
                },
            }
        );
        
        toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
        navigate("/dashboard/maintenance");

      }else{
          const response = await axios.post(
            "https://nanosoft.space/taarteb/public/api/maintenances",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
                },
            }
        );
        
        toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
        navigate("/dashboard/maintenance");

      }

    } catch (error) {
        console.error(error);
        toast.error(
            error.response?.data?.message || "Something went wrong",
            { position: "bottom-right", autoClose: 3000 }
        );
    } finally {
        setLoading(false);
    }
};



    return (
        <div className='add_Maintenance_form_container'>
            <ToastContainer />

            <form className='form_container'                              
                    onSubmit={handleSubmit} 
>
                <Container fluid>
                    <Row>
                        <Col md={6}>
                            <div>
                                <label>{currentLocal.home.description}</label>
                                <br />
                                <div className='mb-3'>
                                    {/* <Select
                                        value={grade_id}
                                        onChange={(selectedOption) => setGrade_id(selectedOption)}
                                        options={options}
                                        placeholder={currentLocal.home.stageName} // Change this text

                                    /> */}
                                    <textarea
                                        placeholder={currentLocal.home.description}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        className='w-100 form-control'
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div>
                                <label>{currentLocal.home.price}</label>
                                <CustomInput
                                    placeholder={currentLocal.home.price}
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}

                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <label>{currentLocal.home.image}</label>

                            <label style={{
                                border: "1px dashed #dee2e6",
                                height: "200px",
                                position:"relative"
                            }}
                                className='d-flex justify-content-center align-items-center flex-column'
                                htmlFor="fileInput"
                            >
                                   <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: "none" }} // نخفي الاختيار الافتراضي
      />
                                {preview ? (
                                    <div className="mt-3 text-center h-100">
                                        <img
                                            src={preview}
                                            alt="preview"
                                            className="img-fluid rounded shadow"
                                            style={{ height: "150px" }}
                                        />
                                        <br />
                                        <button
                                            type="button"
                                            onClick={handleRemoveImage}
                                            className="btn btn-danger btn-sm mt-2 btn_remove"
                                        >
                                            x
                                        </button>
                                    </div>
                                ) :
                                    (
                                        <>
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-card-image" viewBox="0 0 16 16">
                                                    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54L1 12.5v-9a.5.5 0 0 1 .5-.5z" />
                                                </svg>
                                            </div>
                                            {currentLocal.home.UploadMainImage}

                                        </>
                                    )
                                }
                            </label>
                            {/* <div className="d-flex flex-column align-items-center">
      <label
        htmlFor="fileInput"
        className="custom-upload-btn border w-100  px-4 py-2 rounded"
        style={{ cursor: "pointer",height: "25%",}}
      >
        {image ? "Change Image" : "Upload Image"}
      </label>

      <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        style={{ display: "none" }} // نخفي الاختيار الافتراضي
      />

      {preview && (
        <div className="mt-3 text-center">
          <img
            src={preview}
            alt="preview"
            className="img-fluid rounded shadow"
            style={{ maxHeight: "200px" }}
          />
          <br />
          <button
            type="button"
            onClick={handleRemoveImage}
            className="btn btn-danger btn-sm mt-2"
          >
            Remove
          </button>
        </div>
      )}
    </div> */}

                        </Col>




                        <Col md={12}>
                            <div className='d-flex justify-content-center mt-4 '>
                                <div className='w-50 d-flex justify-content-center'>
                                    <CustomBtn text={loading ? currentLocal.home.Loading :id?currentLocal.home.edit: currentLocal.home.add} disabled={loading} clickingFunction={() => { }} />

                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </form>
        </div>
    )
}


export default AddMaintenanceForm
